export default __webpack_public_path__ + "static/media/p2-7.fce78eb1.png";